import $ from 'jquery';

export default function init() {
	/* Custom quantity modifier buttons
	-------------------------------------------------------- */
	function setupCdQty() {

		$('.cd-qty__button--minus').click( function(e) {
			e.preventDefault();
			var newVal = Number($('.cd-qty .qty').val()) - 1;
			if (newVal < 1) newVal = 1;
			$('.cd-qty .qty').val( newVal );
		});

		$('.cd-qty__button--plus').click( function(e) {
			e.preventDefault();
			$('.cd-qty .qty').val( Number($('.cd-qty .qty').val()) + 1 );
		});

	}

	if ($('.cd-qty').length) setupCdQty();
}
